module.exports = __webpack_public_path__ + "static/media/gold-coin-bg-wide-grey.06489af6.jpg";